import CouponInput from './CouponInputV2';

export default CouponInput;
